import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import WhatsAppAutomation from "@/pages/WhatsAppAutomation";
import WhatsAppPricing from "@/pages/WhatsAppPricing";
import BulkWhatsApp from "@/pages/BulkWhatsApp";
import BulkSMS from "@/pages/BulkSMS";
import SmartTelephony from "@/pages/SmartTelephony";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Pricing from "@/pages/Pricing";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/whatsapp-automation" element={<WhatsAppAutomation />} />
          <Route path="/whatsapp-automation/pricing" element={<WhatsAppPricing />} />
          <Route path="/bulk-whatsapp" element={<BulkWhatsApp />} />
          {/* Legacy route redirect */}
          <Route path="/bulk-whatsapp-campaigning" element={<Navigate to="/bulk-whatsapp" replace />} />
          <Route path="/bulk-sms" element={<BulkSMS />} />
          <Route path="/smart-telephony" element={<SmartTelephony />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
      <Toaster position="top-right" richColors closeButton />
    </BrowserRouter>
  );
}

export default App;
